import React, { useEffect, useState } from 'react';
import { Container, Tabs, Tab, Card, ListGroup, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const ClubInfo: React.FC = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('committee');

  useEffect(() => {
    // Check if there's a hash in the URL when component mounts
    if (location.hash === '#history') {
      setActiveTab('history');
    } else if (location.hash === '#committee') {
      setActiveTab('committee');
    } else if (location.hash === '#child-protection') {
      setActiveTab('child-protection');
    } else if (location.hash === '#complaints') {
      setActiveTab('complaints');
    } else if (location.hash === '#fa-respect') {
      setActiveTab('fa-respect');
    }
  }, [location.hash]);

  return (
    <>
      <Helmet>
        <title>Ashridge Park FC | Grassroots Football Club in Wokingham</title>
        <meta name="description" content="Welcome to Ashridge Park FC, a charter standard community football club in Wokingham, Berkshire, offering youth and adult football for all ages." />
      </Helmet>
    
      <Container className="p-3 my-4">
        <h2 className="mb-4">OUR CLUB - ASHRIDGE PARK</h2>
        
        <Tabs 
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k || 'committee')}
          id="club-info-tabs" 
          className="mb-3" 
          fill
        >
                    
          <Tab eventKey="committee" title="Committee Members">
            <div className="p-3">
              <h4 className="mb-4">CLUB COMMITTEE</h4>
              
              <Row className="g-4">
                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Chairman</h6>
                      <h5 className="mb-2">Sean Rolfe</h5>
                      <div className="contact-info">
                        <div className="mb-1">
                          <i className="bi bi-telephone"></i>
                          <a href="tel:07799066221" className="text-decoration-none ms-2">07799 066 221</a>
                        </div>
                        <div>
                          <i className="bi bi-envelope"></i>
                          <a href="mailto:sean_rolfe@hotmail.com" className="text-decoration-none ms-2">sean_rolfe@hotmail.com</a>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">President</h6>
                      <h5 className="mb-2">Ady Dolan</h5>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Child Welfare Officer</h6>
                      <h5 className="mb-2">Marie Forman</h5>
                      <div className="contact-info">
                        <div className="mb-1">
                          <i className="bi bi-telephone"></i>
                          <a href="tel:07941790331" className="text-decoration-none ms-2">07941 790 331</a>
                        </div>
                        <div>
                          <i className="bi bi-envelope"></i>
                          <a href="mailto:mwest372010@gmail.com" className="text-decoration-none ms-2">mwest372010@gmail.com</a>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Secretary</h6>
                      <h5 className="mb-2">James Wyper</h5>
                      <div className="contact-info">
                        <div className="mb-1">
                          <i className="bi bi-telephone"></i>
                          <a href="tel:07947807325" className="text-decoration-none ms-2">07947 807 325</a>
                        </div>
                        <div>
                          <i className="bi bi-envelope"></i>
                          <a href="mailto:wyper.james.r@gmail.com" className="text-decoration-none ms-2">wyper.james.r@gmail.com</a>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Tournament Organiser</h6>
                      <h5 className="mb-2">Kevin McGill</h5>
                      <div className="contact-info">
                        <div>
                          <i className="bi bi-telephone"></i>
                          <a href="tel:07751304757" className="text-decoration-none ms-2">07751 304 757</a>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Kit Secretary</h6>
                      <h5 className="mb-2">Harry Chapman</h5>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Treasurer</h6>
                      <h5 className="mb-2">Matthew Preston</h5>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Head of Girls Football</h6>
                      <h5 className="mb-2">Duncan Owen</h5>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Head of Digital</h6>
                      <h5 className="mb-2">Andrew Foote</h5>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Fixture Secretary</h6>
                      <h5 className="mb-2">Pete Singleton & Vesna Osmanagic</h5>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="h-100">
                    <Card.Body>
                      <h6 className="text-primary mb-3">Head of Equipment</h6>
                      <h5 className="mb-2">Clare Sudlow</h5>
                    </Card.Body>
                  </Card>
                </Col>
                
              </Row>
            </div>
          </Tab>

          <Tab eventKey="history" title="Club History">
            <div className="p-3">
              <h4 className="mb-4">HISTORY OF ASHRIDGE PARK FC</h4>
              
              <div className="timeline">
                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">1991</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">The Beginning</h6>
                      <p>
                        Ian Neilson's son had been playing for Wokingham Youth, but was rarely selected.
                        During a BBQ, Ian discussed this with his next door neighbour, and a family friend, and by the end of their day, they had agreed to form Ashridge Park Football Club with Mr Peter Edwards as Chairman, David Lindsay as Treasurer and Ian Neilson as Club Secretary.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">1992</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">Early Growth</h6>
                      <p>2nd Season in local football, with Ashridge Park operating 5 teams at various age groups.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">1993</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">Rapid Expansion</h6>
                      <p>Size of club quickly reaches 100 members, over 8 teams in 6 age groups.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">1994</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">First Tournament</h6>
                      <p>The first Ashridge Park Summer Tournament was held at St. Crispin's.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">1995</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">International Tours</h6>
                      <p>
                        The Club went on a number of tours as well, the first was a trip to Germany playing on some sort of chalk pitches. Ashridge Park represented Wokingham vs. our twin town Erfstadt.
                      </p>
                      <p>
                        In future years there were to be trips to Bournemouth for tournaments, and we also represented Wokingham in a Twinning Tournament held in France, in which we won all of our games. The Trophy is on display to this day at the Town Hall.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">1997</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">New Leadership</h6>
                      <p>Ian McKenzie and Rosie Ramsay were appointed as Chairman and Secretary respectively.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">1999</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">Men's Section Formation</h6>
                      <p>Ashridge Park Men's section was formed and played in the Bracknell Sunday Men's League.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">2000</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">Digital Era Begins</h6>
                      <p>The original Ashridge Park website was set-up.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">2002</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">Soccer School Launch</h6>
                      <p>Ashridge Park Soccer School was introduced for under 6s. By this time, the Club had 200 members over 11 age groups from under 6 up to Adult.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">2004</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">Leadership Changes</h6>
                      <p>Steve Jones and Ian Blackham were appointed as Chairman and Vice Chairman, with Ian becoming Chairman in 2010.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">2007</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">FA Charter Status</h6>
                      <p>The FA Charter Status was achieved. Neil Coupe was appointed as Secretary, becoming Chair in 2014.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">2010</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">Girls Football Begins</h6>
                      <p>The first Ashridge Park Girls teams were formed.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">2011</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">20th Anniversary</h6>
                      <p>The 20th Year Anniversary was celebrated, and the Club had grown to around 300 members in 25 teams.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">2014</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">Charter Community Status</h6>
                      <p>The Club achieved FA Charter Community Status, the highest level for a grassroots football club.</p>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-marker">
                    <div className="timeline-year">2015</div>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-card">
                      <h6 className="timeline-title">Record Growth</h6>
                      <p>The Club started the season with approximately 325 members playing for a record 28 teams, including 2 men's teams and 2 girls' teams.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Tab>

          <Tab eventKey="child-protection" title="Child Protection Policy">
            <div className="p-3">
              <h4>CHILD PROTECTION POLICY</h4>
              <p>Ashridge Park FC is committed to creating and preserving the safest possible environment for children to play football.</p>
              <p>Every child or young person, defined as any person under the age of 18, who plays or participates in football should be able to take part in an enjoyable and safe environment and be protected from abuse. This is the responsibility of every adult involved in football.</p>
              <p>Ashridge Park FC recognizes its responsibility to safe guard the welfare of all children and young people by protecting them from physical, sexual or emotional harm and from neglect or bullying. It is determined to meet its obligation to ensure that Ashridge Park FC as an organization, which provides football opportunities for children and young people do so, to the highest possible standard of care.</p>
              <p>These procedures apply to anyone in football whether in a paid or voluntary capacity, for example, volunteers, referees, club officials, football coaches and first-aiders.</p>
              <p>Ashridge Park FC accepts children's welfare is paramount and that all children, whatever their age, culture, disability, gender or religion, have the right to protection from abuse. All suspicions and allegations of abuse will be taken seriously and responded to swiftly and appropriately.</p>
              
              <h6>Ashridge Park FC’s aims are:</h6>
              <ul>
                <li>To develop a safe environment in order to protect all children and young people who play football.</li>
                <li>To demonstrate best practice in the area of child protection.</li>
                <li>To ensure that all team managers have completed the Football Association Safeguarding Children Workshop and have clearance through the Criminal Records Bureau.(CRB)</li>
                <li>To ensure that the child's welfare is, and always must be, the paramount consideration.</li>
                <li>To ensure all suspicions of abuse will be taken seriously and responded to swiftly, and appropriately working in partnership with children/parents/carers is essential.</li>
              </ul>

              <p>The following aims should be used in conjunction with the Ashridge Park FC Child Protection Reporting Procedures Guide. These procedures have been developed to reflect the key principles of the FA Child Protection Policy and has such the following documents should be referred to for further guidance.</p>
              <ul>
                <li>The Football Association Child Protection Policy</li>
                <li>The FA Coaches Association Child Protection Policy</li>
                <li>The FA Centres of Excellence</li>
                <li>The FA Safety First.</li>
              </ul>
              <p>The above can be viewed on <a href="http://www.thefa.com/default.aspx" target="_blank" rel="noopener noreferrer">The FA.com</a>.</p>

              <h5 className="mt-4">Ashridge Park FC Child Protection Reporting Procedures</h5>
              <p>The following steps shall be taken should you:</p>
              <ol>
                <li>Have a concern about the welfare of a child or young person.</li>
                <li>A child or young person informs you of a possible abuse situation, or</li>
                <li>Through observation or a third party you become aware of a possible abuse situation.</li>
              </ol>

              <h6 className="mt-4"><strong>Step 1</strong></h6>
              <ul>
                <li>Stay Calm</li>
                <li>If the child or young person is present reassure him/her that they are not to blame.</li>
                <li>Don't make promises of confidentiality or outcome.</li>
                <li>Keep questions to a minimum.</li>
              </ul>

              <h6 className="mt-4"><strong>Step 2</strong></h6>
              <p>Is the child or young person in need of immediate medical attention?</p>
              <p><strong>NO?</strong></p>
              <ul>
                <li>Contact the Child Welfare Officer.</li>
                <li>Do not contact parents at this stage.</li>
                <li>Make a factual record of events and pass to designated person.</li>
                <li>The designated Child Welfare Officer (CWO) will either discuss the situation with other committee members or if action is needed urgently provide the appropriate advice and action to be taken to the confidant. The designated CWO shall then inform the other committee members of the situation as soon as possible after the initial allegation.</li>
                <li>If the designated CWO cannot be contacted straight away seek urgent advice from Local Social Services, the police or The FA/NSPCC helpline. Contact details are given at the end of the Child Protection Report.</li>
              </ul>
              <p><strong>YES?</strong></p>
              <p>MAKE SURE THAT THERE IS AT LEAST ONE OTHER PERSON PRESENT BEFORE PROCEEDING</p>
              <ul>
                <li>Take the young child or person to hospital or telephone an ambulance.</li>
                <li>Inform doctor at the hospital who will take appropriate action.</li>
                <li>Inform the parents/carers immediately unless you have specific reasons not to, then contact Ashridge Park FC 's designated CWO or local Social Services, the Police or The FA/NSPCC helpline for guidance. Contact details are given at the end of the Child Protection Report.</li>
              </ul>

              <h6 className="mt-4"><strong>Step 3</strong></h6>
              <p>If the allegations of abuse involves a member of Ashridge Park FC or another Football team.</p>
              <p>The confidant shall:</p>
              <ul>
                <li>Make a factual record of events as soon as possible.</li>
                <li>Contact the Ashridge Park FC CWO and provide the CWO with the factual record of the events of the allegation of abuse.</li>
                <li>The designated Child Welfare Officer (CWO) will either discuss the situation with other committee members or if action is needed urgently provide the appropriate advice and action to be taken to the confidant. The designated CWO shall then inform the other committee members of the situation as soon as possible after the initial allegation</li>
                <li>If the designated CWO cannot be contacted straight away seek urgent advice from Local Social Services, the police or The FA/NSPCC helpline. Contact details are given at the end of the Child Protection Report.</li>
                <li>Take action advised by these agencies including advice on contacting parents/carers.</li>
                <li>Inform the Ashridge Park FC Management Committee members of the situation as soon as possible after the initial allegation.</li>
              </ul>

              <Card className="mt-4">
                <Card.Header>Contact Information</Card.Header>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong>Child Welfare Officer:</strong> Marie Forman<br/>
                    Mobile: 07941790331<br/>
                    Email: <a href="mailto:mwest372010@gmail.com">mwest372010@gmail.com</a>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>FA/NSPCC Helpline:</strong> 0808 800 5000
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Children’s Services (Wokingham):</strong> 0118 9088230
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </div>
          </Tab>

          <Tab eventKey="complaints" title="Complaints and Grievance Policy">
            <div className="p-3">
              <h4>COMPLAINTS AND GRIEVANCE POLICY</h4>
              <p>In the event of any member feeling that he or she has suffered discrimination in any way, or that the Respect Code of Conduct has been broken they should follow the procedures below.</p>
              <p>Submit a report on the matter to the Club Secretary or any other Management Committee Member.</p>
              <p>The report should include:</p>
              <ul>
                <li>Details of what, when and where, the occurrence took place.</li>
                <li>Any witness statements and names.</li>
                <li>Names of any others who have been treated similarly.</li>
                <li>Details of any former complaints made about the incident, date, when and to whom.</li>
                <li>A preferred solution/remedy to the incident.</li>
              </ul>
              <p>Within 7 days of the report being received by the Secretary, the complainant will be contacted. This may be to seek clarification of points raised, a request for evidence or a simple update etc.</p>
              <p>The individual against whom the complaint has been made will also be informed of the nature of the allegation, at the same time as the complainant is contacted, and is entitled to a formal right of reply.</p>
              <p>Depending on the nature of the complaint and subsequent investigation, the individuals concerned may be invited to meet a sub-committee of officials from the Football Club’s Management Committee via the Club Secretary. When the allegation involves any individuals under 18 years of age, the Child Welfare Officer will be co-opted onto the sub-committee.</p>
              <p>The sub-committee will consider the evidence and deliver its verdict within 3 days.</p>
              <p>If found guilty, any of the punitive measures listed in the Respect Code of Conduct may be applied.</p>
              <p>However, any member found guilty of a breach of the Club Rules has the right to appeal to a full meeting of the Football Club’s Management Committee. The Committee will consider the evidence and deliver its verdict within 3 days.</p>
              <p>An appeal against the Club’s decision may be made to the Football Association.</p>
            </div>
          </Tab>

          <Tab eventKey="fa-respect" title="FA Respect">
            <div className="p-3">
              <h4>F.A. RESPECT PROGRAMME</h4>
              {/* <p>Affiliated to Berks and Bucks FA - Affiliation Number (2025/26):Y-B&B4581.</p> */}
              <p>Affiliated to Berks and Bucks FA</p>
              <p>As a Charter Standard Community Club, Ashridge Park FC is fully committed to supporting the FA's Respect programme. Respect is The FA’s programme to address unacceptable behaviour in football – on and off the pitch.</p>
              <p>To find out how "RESPECT" affects you, whether as a player, coach, manager, parent, spectator or other official, please explore the FA's resources <a href="http://www.thefa.com/get-involved/respect" target="_blank" rel="noopener noreferrer">here</a>.</p>
              
              <h5 className="mt-4"><strong>SUMMARY CODE OF CONDUCT – FAIR PLAY IN FOOTBALL</strong></h5>
              
              <h6><strong>Parents and Spectators:</strong></h6>
              <p>We all have a responsibility to promote high standards of behaviour in the game. This club is supporting The FA's Respect programme to ensure football can be enjoyed by everyone in a safe and positive environment. Play your part and observe The FA's Respect Code of Conduct for spectators and parents/carers at all times.</p>
              <p>I will:</p>
              <ul>
                <li>Remain outside the field of play and behind the Designated Spectator Area (where provided)</li>
                <li>Never engage in, or tolerate, offensive, insulting or abusive language or behaviour</li>
                <li>Always respect the match officials' decisions</li>
                <li>Applaud effort and good play as well as success</li>
                <li>In addition, when attending youth games I will:
                  <ul>
                    <li>Remember that children play for FUN</li>
                    <li>Let the coaches do their job and not confuse the players by telling them what to do</li>
                    <li>Encourage the players to respect the opposition and match officials</li>
                    <li>Never criticise a player for making a mistake - mistakes are part of learning</li>
                  </ul>
                </li>
              </ul>
              <p>I understand that breaches of the code may result in action being taken by my County FA and/or The FA.</p>

              <h6 className="mt-4"><strong>Managers and Coaches:</strong></h6>
              <p>We all have a responsibility to promote high standards of behaviour in the game. Play your part and observe The FA's Respect Code of Conduct for coaches, team managers and club officials at all times.</p>
              <p>I will:</p>
              <ul>
                <li>Show respect to others involved in the game including match officials, opposition players, coaches, managers, officials and spectators</li>
                <li>Adhere to the Laws of the Game</li>
                <li>Display and promote high standards of behaviour</li>
                <li>Always respect the match officials' decisions</li>
                <li>Never enter the field of play without the referee's permission</li>
                <li>Never engage in public criticism of the match officials</li>
                <li>Never engage in, or tolerate, offensive, insulting or abusive language or behaviour.</li>
                <li>When working with players, I will:
                  <ul>
                    <li>Place the well-being, safety and enjoyment of each player above everything, including winning</li>
                    <li>Explain exactly what I expect of players and what they can expect from me</li>
                    <li>Ensure the parents/carers of all players under the age of 18 understand these expectations</li>
                    <li>Refrain from, and refuse to tolerate any form of bullying</li>
                    <li>Develop mutual trust and respect with every player to build their self-esteem</li>
                    <li>Encourage each player to accept responsibility for their own behaviour and performance</li>
                    <li>Ensure all activities I organise are appropriate for the players' ability level, experience, age and maturity</li>
                    <li>Co-operate fully with others in football (e.g. officials, doctors, physiotherapists, welfare officers) for each player's best interests</li>
                  </ul>
                </li>
              </ul>
              <p>I understand that breaches of the code may result in action being taken by my County FA and/or The FA.</p>

              <h6 className="mt-4"><strong>Players:</strong></h6>
              <p>When playing football, I will:</p>
              <ul>
                <li>Always do my best, even if we're losing or the other team is stronger</li>
                <li>Play fairly - I won't cheat, complain or waste time</li>
                <li>Never be rude to my team-mates, the other team, the referee, spectators or my coach/team manager</li>
                <li>Do what the referee tells me</li>
                <li>Shake hands with the other team and referee at the end of the game</li>
                <li>Listen to my coach/team manager and respect what he/she says</li>
                <li>Talk to someone I trust, for example my parents or the club welfare officer if I'm unhappy about anything at my club.</li>
              </ul>
              <p>I understand that if I do not follow the code, action may be taken.</p>
            </div>
          </Tab>

        </Tabs>
      </Container>
    </>
  );
};

export default ClubInfo;